<div class="ia-prompt-card-container">
  <div  class="ia-prompt-card">
    <div class="ia-response" *ngIf="(messages|async)?.length > 0">

        <ng-container *ngFor="let conv of messages|async; let i = index" >
          <div class="user-question right" *ngIf="conv.role === 'user'">
            <p (click)="onAlterarFluxo($event)" [innerHTML]="sanitizer.bypassSecurityTrustHtml(iaService.convertTextToHtml(conv.text))">conv.text</p>
          </div>
          <div class="response-item left" *ngIf="conv.role === 'assistant'"> 
            <p (click)="onAlterarFluxo($event)" [innerHTML]="sanitizer.bypassSecurityTrustHtml(iaService.convertTextToHtml(conv.text))"></p>
            <div class="feedback">
              <button nz-button nzShape="circle" nzSize="small" [nzType]="conv.feedback=='up' ? 'primary' : 'default'" (click)="feedback(i, true)"  nz-tooltip  [nzTooltipTitle]="'ia.positeve'|translateTA">
                <i nz-icon nzType="like" nzTheme="outline"></i>
              </button>
              <button nz-button nzShape="circle" nzSize="small" (click)="feedback(i, false)"  [nzType]="conv.feedback=='down' ? 'primary' : 'default'" nz-tooltip  [nzTooltipTitle]="'ia.negative'|translateTA">
                <i nz-icon nzType="dislike" nzTheme="outline"></i>
              </button>
            </div>
          </div>
        </ng-container> 
      </div>


      <!-- GIF de carregamento -->
      <div class="ia-loading" *ngIf="loading || initLoading">
        <img src="assets/image/ia.gif" alt="loading" class="loading-gif" />
      </div>

      <mat-divider></mat-divider>
      <!-- Campo de entrada -->
      <div class="ia-input-area">
          <input
            nz-input
            [(ngModel)]="userPrompt"
            placeholder="{{'ia.workflow.flow.creator'|translateTA}}"
            class="ia-textarea"
            (keyup.enter)="enviarPrompt()"
          />

          <!-- Botão de envio -->
          <div class="ia-actions">
            <button
              nz-button
              nzType="primary"
              [disabled]="!userPrompt || loading || initLoading"
              (click)="enviarPrompt()"
            >
              <i nz-icon nzType="send" nzTheme="outline"></i>
              {{'ia.send'|translateTA}}
            </button>
          </div>
        </div>

  </div>
</div>

